import { render, staticRenderFns } from "./authentication.vue?vue&type=template&id=74b39ddc&"
import script from "./authentication.vue?vue&type=script&lang=ts&"
export * from "./authentication.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports